import styles from './palette.module.scss';
import { guid } from 'services/util';
import cx from 'classnames';

export const buttons = [{
  id: 'regular_button_one',
  name: 'Regular Button One',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonOne)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_two',
  name: 'Regular Button Two',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonTwo)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 224,
            "g": 224,
            "b": 224,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 224,
            "g": 224,
            "b": 224,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 224,
            "g": 224,
            "b": 224,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 224,
            "g": 224,
            "b": 224,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_three',
  name: 'Regular Button Three',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonThree)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "470px, 553px",
            "rotate": "0deg"
          },
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 198,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "57.5px, 553px",
            "rotate": "0deg"
          },
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 198,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_four',
  name: 'Regular Button Four',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonFour)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 158,
            "g": 158,
            "b": 158,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 158,
            "g": 158,
            "b": 158,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 33,
            "g": 33,
            "b": 33,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "10",
              "topRight": "10",
              "bottomLeft": "10",
              "bottomRight": "10"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_five',
  name: 'Regular Button Five',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonFive)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 0
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            },
            "width": "1",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            },
            "width": "1",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 0
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            },
            "width": "1",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            },
            "width": "1",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_six',
  name: 'Regular Button Six',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonSix)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 232,
            "b": 153,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 198,
              "b": 0,
              "a": 1
            },
            "width": "1",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 198,
              "b": 0,
              "a": 1
            },
            "width": "1",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 232,
            "b": 153,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 198,
              "b": 0,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 198,
              "b": 0,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_seven',
  name: 'Regular Button Seven',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonSeven)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 0
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "130px",
          "height": "41px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 0
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_eight',
  name: 'Regular Button Eight',
  render: () => {
    return <button className={cx(styles.paletteButtons, styles.regularButtonEight)}>Button Text</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "65px",
          "height": "65px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 189,
            "g": 189,
            "b": 189,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "65px",
          "height": "65px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 189,
            "g": 189,
            "b": 189,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Button Text'
  },
}, {
  id: 'regular_button_nine',
  name: 'Regular Button Nine',
  render: () => {
    return <button className={styles.regularButtonNine}>Go</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "470px, 553px",
            "rotate": "0deg"
          },
          "width": "65px",
          "height": "65px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 189,
            "g": 189,
            "b": 189,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "100",
              "topRight": "100",
              "bottomLeft": "100",
              "bottomRight": "100"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "57.5px, 553px",
            "rotate": "0deg"
          },
          "width": "65px",
          "height": "65px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 189,
            "g": 189,
            "b": 189,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Go'
  },
}, {
  id: 'regular_button_ten',
  name: 'Regular Button Ten',
  render: () => {
    return <button className={styles.regularButtonTen}>Big Button</button>
  },
  data: {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "width": "192px",
          "height": "65px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "24",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "24",
              "topRight": "24",
              "bottomLeft": "24",
              "bottomRight": "24"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "hover": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 189,
            "g": 189,
            "b": 189,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "24",
              "topRight": "24",
              "bottomLeft": "24",
              "bottomRight": "24"
            }
          },
          "shadow": {
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "axes": {
              "x": "0",
              "y": "0",
              "b": "0"
            },
            "show": false
          }
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "width": "192px",
          "height": "65px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "24",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 238,
            "g": 238,
            "b": 238,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "24",
              "topRight": "24",
              "bottomLeft": "24",
              "bottomRight": "24"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 33,
              "g": 33,
              "b": 33,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 189,
            "g": 189,
            "b": 189,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": {
              "type": "solid",
              "r": 255,
              "g": 255,
              "b": 255,
              "a": 1
            },
            "width": "0",
            "radius": {
              "lock": false,
              "topLeft": "24",
              "topRight": "24",
              "bottomLeft": "24",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: 'Big Button'
  },
}]